import { ProductTier } from '@sparemin/api-sdk';
import React from 'react';
import { useDispatch } from 'react-redux';

import { onErrorNotification } from 'redux/modules/mixpanel';
import { replaceModal } from 'redux/modules/modal';

import DurationLimitErrorModalContents from './DurationLimitErrorModalContents';

const DurationLimitErrorModalContentsContainer: React.FunctionComponent = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(onErrorNotification('This audio is too long for your tier'));
  }, [dispatch]);

  const handleIncreaseDurationLimit = React.useCallback(() => {
    dispatch(
      replaceModal({
        name: 'AddBillingCycle',
        params: {
          tier: ProductTier.PRO,
          defaultSubscriptionPeriod: 'yearly',
        },
      }),
    );
  }, [dispatch]);

  return (
    <DurationLimitErrorModalContents
      onIncreaseDurationLimit={handleIncreaseDurationLimit}
    />
  );
};

export default DurationLimitErrorModalContentsContainer;
